/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the Tocsoft.GraphQLCodeGen toolchain https://github.com/tocsoft/GraphQLCodeGen
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import {HttpClient} from 'aurelia-fetch-client';
import {inject} from 'aurelia-framework';
import { apiUrl } from '../../constants'

interface fetchClient {
    fetch(url: RequestInfo, init: RequestInit): Promise<Response>
}

class GraphQLResponse
{
    data: any
    errors: Array<{ message: string }>
}

function CreateUpdateApplicationError(message:string, httpResponse:Response, graphqlResponse?: GraphQLResponse) {
    this.name = 'CreateUpdateApplicationError';
    this.message = message || 'Error fetching graphql response';
    this.stack = (new Error()).stack;
    this.httpResponse = httpResponse;
    if(graphqlResponse && graphqlResponse.errors){
        this.errors = graphqlResponse.errors.map(x=>x.message);
    }
  }
  CreateUpdateApplicationError.prototype = Object.create(Error.prototype);
  CreateUpdateApplicationError.prototype.constructor = CreateUpdateApplicationError;
  
export { CreateUpdateApplicationError }

@inject(HttpClient, apiUrl)
export class CreateUpdateApplicationClient {

    constructor(public client: fetchClient, public url: string) { }
	
	createUpdateApplication_update(	app? :ClaimApplicationDtoInput) : Promise<CreateUpdateApplicationUpdateResult>{
        return this.client.fetch(this.url, {
            method : 'POST',
            body : JSON.stringify({
                query : `mutation update($app: ClaimApplicationDtoInput) {
  addUpdateClaimApplication(claimApplication: $app) {
    result {
      id
      ownerId
      reporter {
        contact {
          id
        }
      }
      claimant {
        contact {
          id
        }
      }
    }
    accessToken
    isLocked
  }
}
`,
                variables : {
					app : app ,
                }
            })
        }).then(response=>{
            if(response.status != 200){
                // error result
                throw new CreateUpdateApplicationError("http error running 'createUpdateApplication_update', see httpResponse for more details.", response)
            }else{
                return response.json().then((json:GraphQLResponse)=>{
                    
                    if(json.errors && json.errors.length > 0){
                        throw new CreateUpdateApplicationError("graphql error(s) running 'createUpdateApplication_update', see errors collection fro more details", response, json)
                    }

                    const result: any = CreateUpdateApplicationUpdateResult.fromJS(json.data);                
                    
                    return result;
                })
            }
        })
    }	
}

export class DocumentDtoInput {
		fileId :string;
		fileName? :string;
		fileType? :string;
		fileSize :number;
		id? :string;
		dateCreated? :Date;

    static fromJS(json:any):DocumentDtoInput{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new DocumentDtoInput();

	result.fileId = json["fileId"];
	result.fileName = json["fileName"];
	result.fileType = json["fileType"];
	result.fileSize = json["fileSize"];
	result.id = json["id"];
result.dateCreated = json["dateCreated"] ? new Date(json["dateCreated"]) : null;

        return result;
    }
}

export class AddressDtoInput {
		address1? :string;
		address2? :string;
		address3? :string;
		town? :string;
		postcode? :string;
		country? :CountryCodeType;
		dateCreated? :Date;

    static fromJS(json:any):AddressDtoInput{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new AddressDtoInput();

	result.address1 = json["address1"];
	result.address2 = json["address2"];
	result.address3 = json["address3"];
	result.town = json["town"];
	result.postcode = json["postcode"];
result.country= CountryCodeType[<string>json["country"]];
result.dateCreated = json["dateCreated"] ? new Date(json["dateCreated"]) : null;

        return result;
    }
}

export class ContactDtoInput {
		contactType? :string;
		title? :string;
		firstname? :string;
		surname? :string;
		companyName? :string;
		telephoneCountryCode? :CountryCodeType;
		telephone? :string;
		email? :string;
		relationshipToLeadClaimant? :string;
		relationshipToLeadClaimantFamilyMember? :string;
		isLeadClaimant? :boolean;
		address? :AddressDtoInput;
		correspondenceMethod? :string;
		id? :string;
		dateCreated? :Date;

    static fromJS(json:any):ContactDtoInput{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new ContactDtoInput();

	result.contactType = json["contactType"];
	result.title = json["title"];
	result.firstname = json["firstname"];
	result.surname = json["surname"];
	result.companyName = json["companyName"];
result.telephoneCountryCode= CountryCodeType[<string>json["telephoneCountryCode"]];
	result.telephone = json["telephone"];
	result.email = json["email"];
	result.relationshipToLeadClaimant = json["relationshipToLeadClaimant"];
	result.relationshipToLeadClaimantFamilyMember = json["relationshipToLeadClaimantFamilyMember"];
	result.isLeadClaimant = json["isLeadClaimant"];
result.address= AddressDtoInput.fromJS(json["address"]);
	result.correspondenceMethod = json["correspondenceMethod"];
	result.id = json["id"];
result.dateCreated = json["dateCreated"] ? new Date(json["dateCreated"]) : null;

        return result;
    }
}

export class ReporterDtoInput {
		contact? :ContactDtoInput;
		isRepresenting? :boolean;
		securityQuestion? :string;
		securityAnswer? :string;
		dateCreated? :Date;

    static fromJS(json:any):ReporterDtoInput{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new ReporterDtoInput();

result.contact= ContactDtoInput.fromJS(json["contact"]);
	result.isRepresenting = json["isRepresenting"];
	result.securityQuestion = json["securityQuestion"];
	result.securityAnswer = json["securityAnswer"];
result.dateCreated = json["dateCreated"] ? new Date(json["dateCreated"]) : null;

        return result;
    }
}

export class ClaimantDtoInput {
		contact? :ContactDtoInput;
		appointRepresentative? :boolean;
		representative? :ContactDtoInput;
		anyAdditionalClaimants? :boolean;
		additionalClaimants? :Array<ContactDtoInput>;
		dateCreated? :Date;

    static fromJS(json:any):ClaimantDtoInput{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new ClaimantDtoInput();

result.contact= ContactDtoInput.fromJS(json["contact"]);
	result.appointRepresentative = json["appointRepresentative"];
result.representative= ContactDtoInput.fromJS(json["representative"]);
	result.anyAdditionalClaimants = json["anyAdditionalClaimants"];
if(json["additionalClaimants"]){ 
		result.additionalClaimants = json["additionalClaimants"].map(v=>ContactDtoInput.fromJS(v) );	
	}
result.dateCreated = json["dateCreated"] ? new Date(json["dateCreated"]) : null;

        return result;
    }
}

export class PropertyDtoInput {
		address? :AddressDtoInput;
		policyKnown? :boolean;
		policyNumber? :string;
		propertyType? :string;
		residentialPropertyType? :string;
		commercialPropertyType? :string;
		ownershipType? :string;
		freeholder? :ContactDtoInput;
		newBuildOrConversion? :string;
		hasAgent? :boolean;
		agent? :ContactDtoInput;
		purchased? :boolean;
		agreementDate? :Date;
		purchaseDate? :Date;
		purchasePrice? :string;
		reduced? :boolean;
		reductionAmount? :string;
		reasonReduced? :string;
		retention? :boolean;
		retentionAmount? :string;
		retentionReason? :string;
		surveyCompleted? :boolean;
		noSurveyReason? :string;
		buildingWork? :boolean;
		buildingWorkDetails? :string;
		previousClaim? :boolean;
		previousClaimDetails? :string;
		otherInsurance? :boolean;
		otherInsuranceDetails? :string;
		usage? :string;
		selfBuild? :boolean;
		selfBuildStartDate? :Date;
		overseeingBuilderEmployed? :boolean;
		overseeingBuilder? :ContactDtoInput;
		overseeingBuilderStartDate? :Date;
		contractorDetails? :string;
		anyContractualRemedy? :boolean;
		contractualRemedyDetails? :string;
		dateCreated? :Date;

    static fromJS(json:any):PropertyDtoInput{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new PropertyDtoInput();

result.address= AddressDtoInput.fromJS(json["address"]);
	result.policyKnown = json["policyKnown"];
	result.policyNumber = json["policyNumber"];
	result.propertyType = json["propertyType"];
	result.residentialPropertyType = json["residentialPropertyType"];
	result.commercialPropertyType = json["commercialPropertyType"];
	result.ownershipType = json["ownershipType"];
result.freeholder= ContactDtoInput.fromJS(json["freeholder"]);
	result.newBuildOrConversion = json["newBuildOrConversion"];
	result.hasAgent = json["hasAgent"];
result.agent= ContactDtoInput.fromJS(json["agent"]);
	result.purchased = json["purchased"];
result.agreementDate = json["agreementDate"] ? new Date(json["agreementDate"]) : null;
result.purchaseDate = json["purchaseDate"] ? new Date(json["purchaseDate"]) : null;
	result.purchasePrice = json["purchasePrice"];
	result.reduced = json["reduced"];
	result.reductionAmount = json["reductionAmount"];
	result.reasonReduced = json["reasonReduced"];
	result.retention = json["retention"];
	result.retentionAmount = json["retentionAmount"];
	result.retentionReason = json["retentionReason"];
	result.surveyCompleted = json["surveyCompleted"];
	result.noSurveyReason = json["noSurveyReason"];
	result.buildingWork = json["buildingWork"];
	result.buildingWorkDetails = json["buildingWorkDetails"];
	result.previousClaim = json["previousClaim"];
	result.previousClaimDetails = json["previousClaimDetails"];
	result.otherInsurance = json["otherInsurance"];
	result.otherInsuranceDetails = json["otherInsuranceDetails"];
	result.usage = json["usage"];
	result.selfBuild = json["selfBuild"];
result.selfBuildStartDate = json["selfBuildStartDate"] ? new Date(json["selfBuildStartDate"]) : null;
	result.overseeingBuilderEmployed = json["overseeingBuilderEmployed"];
result.overseeingBuilder= ContactDtoInput.fromJS(json["overseeingBuilder"]);
result.overseeingBuilderStartDate = json["overseeingBuilderStartDate"] ? new Date(json["overseeingBuilderStartDate"]) : null;
	result.contractorDetails = json["contractorDetails"];
	result.anyContractualRemedy = json["anyContractualRemedy"];
	result.contractualRemedyDetails = json["contractualRemedyDetails"];
result.dateCreated = json["dateCreated"] ? new Date(json["dateCreated"]) : null;

        return result;
    }
}

export class EvidenceDtoInput {
		evidenceType? :string;
		description? :string;
		documents? :Array<DocumentDtoInput>;
		contactId? :string;
		requiresApproval? :boolean;
		approved? :boolean;
		approvalAdminNotes? :string;
		approvalDecisionBy? :string;
		approvalDecisionById? :string;
		documentType? :string;
		id? :string;
		dateCreated? :Date;

    static fromJS(json:any):EvidenceDtoInput{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new EvidenceDtoInput();

	result.evidenceType = json["evidenceType"];
	result.description = json["description"];
if(json["documents"]){ 
		result.documents = json["documents"].map(v=>DocumentDtoInput.fromJS(v) );	
	}
	result.contactId = json["contactId"];
	result.requiresApproval = json["requiresApproval"];
	result.approved = json["approved"];
	result.approvalAdminNotes = json["approvalAdminNotes"];
	result.approvalDecisionBy = json["approvalDecisionBy"];
	result.approvalDecisionById = json["approvalDecisionById"];
	result.documentType = json["documentType"];
	result.id = json["id"];
result.dateCreated = json["dateCreated"] ? new Date(json["dateCreated"]) : null;

        return result;
    }
}

export class IssueDtoInput {
		area? :string;
		details? :string;
		dateEvident? :Date;
		builderNotified? :boolean;
		builderNotifiedDate? :Date;
		builderNotifiedEvidence? :boolean;
		reportCarriedOut? :boolean;
		reportDetails? :string;
		waterIngress? :boolean;
		waterIngressDetails? :string;
		fireSafetyRisk? :boolean;
		fireSafetyRiskList? :Array<string>;
		evidence? :Array<EvidenceDtoInput>;
		id? :string;
		dateCreated? :Date;

    static fromJS(json:any):IssueDtoInput{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new IssueDtoInput();

	result.area = json["area"];
	result.details = json["details"];
result.dateEvident = json["dateEvident"] ? new Date(json["dateEvident"]) : null;
	result.builderNotified = json["builderNotified"];
result.builderNotifiedDate = json["builderNotifiedDate"] ? new Date(json["builderNotifiedDate"]) : null;
	result.builderNotifiedEvidence = json["builderNotifiedEvidence"];
	result.reportCarriedOut = json["reportCarriedOut"];
	result.reportDetails = json["reportDetails"];
	result.waterIngress = json["waterIngress"];
	result.waterIngressDetails = json["waterIngressDetails"];
	result.fireSafetyRisk = json["fireSafetyRisk"];
	result.fireSafetyRiskList = json["fireSafetyRiskList"];
if(json["evidence"]){ 
		result.evidence = json["evidence"].map(v=>EvidenceDtoInput.fromJS(v) );	
	}
	result.id = json["id"];
result.dateCreated = json["dateCreated"] ? new Date(json["dateCreated"]) : null;

        return result;
    }
}

export class DeclarationDtoInput {
		additionalInfo? :string;
		declarationConfirmation? :boolean;
		statementOfTruthConfirmation? :boolean;
		dateCreated? :Date;

    static fromJS(json:any):DeclarationDtoInput{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new DeclarationDtoInput();

	result.additionalInfo = json["additionalInfo"];
	result.declarationConfirmation = json["declarationConfirmation"];
	result.statementOfTruthConfirmation = json["statementOfTruthConfirmation"];
result.dateCreated = json["dateCreated"] ? new Date(json["dateCreated"]) : null;

        return result;
    }
}

export class ClaimApplicationDtoInput {
		id? :string;
		ownerId? :string;
		status? :ClaimStatus;
		outputDocument? :DocumentDtoInput;
		reporter? :ReporterDtoInput;
		claimant? :ClaimantDtoInput;
		property? :PropertyDtoInput;
		issues? :Array<IssueDtoInput>;
		evidence? :Array<EvidenceDtoInput>;
		declaration? :DeclarationDtoInput;
		isDuplicate? :boolean;
		screeningInformationViewed :PolicyType;
		dateCreated? :Date;

    static fromJS(json:any):ClaimApplicationDtoInput{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new ClaimApplicationDtoInput();

	result.id = json["id"];
	result.ownerId = json["ownerId"];
result.status= ClaimStatus[<string>json["status"]];
result.outputDocument= DocumentDtoInput.fromJS(json["outputDocument"]);
result.reporter= ReporterDtoInput.fromJS(json["reporter"]);
result.claimant= ClaimantDtoInput.fromJS(json["claimant"]);
result.property= PropertyDtoInput.fromJS(json["property"]);
if(json["issues"]){ 
		result.issues = json["issues"].map(v=>IssueDtoInput.fromJS(v) );	
	}
if(json["evidence"]){ 
		result.evidence = json["evidence"].map(v=>EvidenceDtoInput.fromJS(v) );	
	}
result.declaration= DeclarationDtoInput.fromJS(json["declaration"]);
	result.isDuplicate = json["isDuplicate"];
result.screeningInformationViewed= PolicyType[<string>json["screeningInformationViewed"]];
result.dateCreated = json["dateCreated"] ? new Date(json["dateCreated"]) : null;

        return result;
    }
}

export class CreateUpdateApplicationUpdateResult {
		addUpdateClaimApplication? :ClaimApplicationResultResult;

    static fromJS(json:any):CreateUpdateApplicationUpdateResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new CreateUpdateApplicationUpdateResult();

result.addUpdateClaimApplication= ClaimApplicationResultResult.fromJS(json["addUpdateClaimApplication"]);

        return result;
    }
}

export class ClaimApplicationResultResult {
		result? :ClaimApplicationDtoResult;
		accessToken? :string;
		isLocked :boolean;

    static fromJS(json:any):ClaimApplicationResultResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new ClaimApplicationResultResult();

result.result= ClaimApplicationDtoResult.fromJS(json["result"]);
	result.accessToken = json["accessToken"];
	result.isLocked = json["isLocked"];

        return result;
    }
}

export class ClaimApplicationDtoResult {
		id? :string;
		ownerId? :string;
		reporter? :ReporterDtoResult;
		claimant? :ClaimantDtoResult;

    static fromJS(json:any):ClaimApplicationDtoResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new ClaimApplicationDtoResult();

	result.id = json["id"];
	result.ownerId = json["ownerId"];
result.reporter= ReporterDtoResult.fromJS(json["reporter"]);
result.claimant= ClaimantDtoResult.fromJS(json["claimant"]);

        return result;
    }
}

export class ReporterDtoResult {
		contact? :ContactDtoResult;

    static fromJS(json:any):ReporterDtoResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new ReporterDtoResult();

result.contact= ContactDtoResult.fromJS(json["contact"]);

        return result;
    }
}

export class ContactDtoResult {
		id? :string;

    static fromJS(json:any):ContactDtoResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new ContactDtoResult();

	result.id = json["id"];

        return result;
    }
}

export class ClaimantDtoResult {
		contact? :ContactDtoResult;

    static fromJS(json:any):ClaimantDtoResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new ClaimantDtoResult();

result.contact= ContactDtoResult.fromJS(json["contact"]);

        return result;
    }
}


	export enum ClaimStatus
	{
		INCOMPLETE = "INCOMPLETE",
		SUBMITTED = "SUBMITTED",
		REVIEWED = "REVIEWED",
		ARCHIVED = "ARCHIVED",
	}

	export enum CountryCodeType
	{
		NONE = "NONE",
		AFGHANISTAN = "AFGHANISTAN",
		ALBANIA = "ALBANIA",
		ALGERIA = "ALGERIA",
		AMERICANSAMOA = "AMERICANSAMOA",
		ANDORRA = "ANDORRA",
		ANGOLA = "ANGOLA",
		ANGUILLA = "ANGUILLA",
		ANTARCTICA = "ANTARCTICA",
		ARGENTINA = "ARGENTINA",
		ARMENIA = "ARMENIA",
		ARUBA = "ARUBA",
		AUSTRALIA = "AUSTRALIA",
		AUSTRIA = "AUSTRIA",
		AZERBAIJAN = "AZERBAIJAN",
		BAHAMAS = "BAHAMAS",
		BAHRAIN = "BAHRAIN",
		BANGLADESH = "BANGLADESH",
		BARBADOS = "BARBADOS",
		BELARUS = "BELARUS",
		BELGIUM = "BELGIUM",
		BELIZE = "BELIZE",
		BENIN = "BENIN",
		BERMUDA = "BERMUDA",
		BHUTAN = "BHUTAN",
		BOLIVIA = "BOLIVIA",
		BOSNIAANDHERZEGOVINA = "BOSNIAANDHERZEGOVINA",
		BOTSWANA = "BOTSWANA",
		BRAZIL = "BRAZIL",
		BRITISHVIRGINISLANDS = "BRITISHVIRGINISLANDS",
		BRUNEI = "BRUNEI",
		BULGARIA = "BULGARIA",
		BURKINAFASO = "BURKINAFASO",
		BURUNDI = "BURUNDI",
		CAMBODIA = "CAMBODIA",
		CAMEROON = "CAMEROON",
		CANADA = "CANADA",
		CAPEVERDE = "CAPEVERDE",
		CAYMANISLANDS = "CAYMANISLANDS",
		CENTRALAFRICANREPUBLIC = "CENTRALAFRICANREPUBLIC",
		CHILE = "CHILE",
		CHINA = "CHINA",
		COLOMBIA = "COLOMBIA",
		COMOROS = "COMOROS",
		COOKISLANDS = "COOKISLANDS",
		COSTARICA = "COSTARICA",
		CROATIA = "CROATIA",
		CUBA = "CUBA",
		CURACAO = "CURACAO",
		CYPRUS = "CYPRUS",
		CZECHREPUBLIC = "CZECHREPUBLIC",
		DEMOCRATICREPUBLICOFCONGO = "DEMOCRATICREPUBLICOFCONGO",
		DENMARK = "DENMARK",
		DJIBOUTI = "DJIBOUTI",
		DOMINICA = "DOMINICA",
		DOMINICANREPUBLIC = "DOMINICANREPUBLIC",
		EASTTIMOR = "EASTTIMOR",
		ECUADOR = "ECUADOR",
		EGYPT = "EGYPT",
		ELSALVADOR = "ELSALVADOR",
		EQUATORIALGUINEA = "EQUATORIALGUINEA",
		ERITREA = "ERITREA",
		ESTONIA = "ESTONIA",
		ETHIOPIA = "ETHIOPIA",
		FALKLANDISLANDS = "FALKLANDISLANDS",
		FAROEISLANDS = "FAROEISLANDS",
		FIJI = "FIJI",
		FINLAND = "FINLAND",
		FRANCE = "FRANCE",
		FRENCHPOLYNESIA = "FRENCHPOLYNESIA",
		GABON = "GABON",
		GAMBIA = "GAMBIA",
		GEORGIA = "GEORGIA",
		GERMANY = "GERMANY",
		GHANA = "GHANA",
		GIBRALTAR = "GIBRALTAR",
		GREECE = "GREECE",
		GREENLAND = "GREENLAND",
		GUADELOUPE = "GUADELOUPE",
		GUAM = "GUAM",
		GUATEMALA = "GUATEMALA",
		GUINEA = "GUINEA",
		GUINEABISSAU = "GUINEABISSAU",
		GUYANA = "GUYANA",
		HAITI = "HAITI",
		HONDURAS = "HONDURAS",
		HONGKONG = "HONGKONG",
		HUNGARY = "HUNGARY",
		ICELAND = "ICELAND",
		INDIA = "INDIA",
		INDONESIA = "INDONESIA",
		IRAN = "IRAN",
		IRAQ = "IRAQ",
		IRELAND = "IRELAND",
		ISLEOFMAN = "ISLEOFMAN",
		ISRAEL = "ISRAEL",
		ITALY = "ITALY",
		IVORYCOAST = "IVORYCOAST",
		JAMAICA = "JAMAICA",
		JAPAN = "JAPAN",
		JORDAN = "JORDAN",
		KAZAKHSTAN = "KAZAKHSTAN",
		KENYA = "KENYA",
		KIRIBATI = "KIRIBATI",
		KOSOVO = "KOSOVO",
		KUWAIT = "KUWAIT",
		KYRGYZSTAN = "KYRGYZSTAN",
		LAOS = "LAOS",
		LATVIA = "LATVIA",
		LEBANON = "LEBANON",
		LESOTHO = "LESOTHO",
		LIBERIA = "LIBERIA",
		LIBYA = "LIBYA",
		LIECHTENSTEIN = "LIECHTENSTEIN",
		LITHUANIA = "LITHUANIA",
		LUXEMBOURG = "LUXEMBOURG",
		MACAU = "MACAU",
		MACEDONIA = "MACEDONIA",
		MADAGASCAR = "MADAGASCAR",
		MALAWI = "MALAWI",
		MALAYSIA = "MALAYSIA",
		MALDIVES = "MALDIVES",
		MALI = "MALI",
		MALTA = "MALTA",
		MARSHALLISLANDS = "MARSHALLISLANDS",
		MAURITANIA = "MAURITANIA",
		MAURITIUS = "MAURITIUS",
		MEXICO = "MEXICO",
		MICRONESIA = "MICRONESIA",
		MOLDOVA = "MOLDOVA",
		MONACO = "MONACO",
		MONGOLIA = "MONGOLIA",
		MONTENEGRO = "MONTENEGRO",
		MONTSERRAT = "MONTSERRAT",
		MOROCCO = "MOROCCO",
		MOZAMBIQUE = "MOZAMBIQUE",
		MYANMARBURMA = "MYANMARBURMA",
		NAMIBIA = "NAMIBIA",
		NAURU = "NAURU",
		NEPAL = "NEPAL",
		NETHERLANDS = "NETHERLANDS",
		NEWCALEDONIA = "NEWCALEDONIA",
		NEWZEALAND = "NEWZEALAND",
		NICARAGUA = "NICARAGUA",
		NIGER = "NIGER",
		NIGERIA = "NIGERIA",
		NIUE = "NIUE",
		NORFOLKISLAND = "NORFOLKISLAND",
		NORTHKOREA = "NORTHKOREA",
		NORTHERNMARIANAISLANDS = "NORTHERNMARIANAISLANDS",
		NORWAY = "NORWAY",
		OMAN = "OMAN",
		PAKISTAN = "PAKISTAN",
		PALAU = "PALAU",
		PANAMA = "PANAMA",
		PAPUANEWGUINEA = "PAPUANEWGUINEA",
		PARAGUAY = "PARAGUAY",
		PERU = "PERU",
		PHILIPPINES = "PHILIPPINES",
		PITCAIRNISLANDS = "PITCAIRNISLANDS",
		POLAND = "POLAND",
		PORTUGAL = "PORTUGAL",
		PUERTORICO = "PUERTORICO",
		QATAR = "QATAR",
		REPUBLICOFTHECONGO = "REPUBLICOFTHECONGO",
		REUNION = "REUNION",
		ROMANIA = "ROMANIA",
		RUSSIA = "RUSSIA",
		RWANDA = "RWANDA",
		SAINTBARTHELEMY = "SAINTBARTHELEMY",
		SAINTHELENA = "SAINTHELENA",
		SAINTKITTSANDNEVIS = "SAINTKITTSANDNEVIS",
		SAINTLUCIA = "SAINTLUCIA",
		SAINTMARTIN = "SAINTMARTIN",
		SAINTPIERREANDMIQUELON = "SAINTPIERREANDMIQUELON",
		SAINTVINCENTANDTHEGRENADINES = "SAINTVINCENTANDTHEGRENADINES",
		SAMOA = "SAMOA",
		SANMARINO = "SANMARINO",
		SAOTOMEANDPRINCIPE = "SAOTOMEANDPRINCIPE",
		SAUDIARABIA = "SAUDIARABIA",
		SENEGAL = "SENEGAL",
		SERBIA = "SERBIA",
		SEYCHELLES = "SEYCHELLES",
		SIERRALEONE = "SIERRALEONE",
		SINGAPORE = "SINGAPORE",
		SLOVAKIA = "SLOVAKIA",
		SLOVENIA = "SLOVENIA",
		SOLOMONISLANDS = "SOLOMONISLANDS",
		SOMALIA = "SOMALIA",
		SOUTHAFRICA = "SOUTHAFRICA",
		SOUTHKOREA = "SOUTHKOREA",
		SOUTHSUDAN = "SOUTHSUDAN",
		SPAIN = "SPAIN",
		SRILANKA = "SRILANKA",
		SUDAN = "SUDAN",
		SURINAME = "SURINAME",
		SWAZILAND = "SWAZILAND",
		SWEDEN = "SWEDEN",
		SWITZERLAND = "SWITZERLAND",
		SYRIA = "SYRIA",
		TAIWAN = "TAIWAN",
		TAJIKISTAN = "TAJIKISTAN",
		TANZANIA = "TANZANIA",
		THAILAND = "THAILAND",
		TOGO = "TOGO",
		TOKELAU = "TOKELAU",
		TRINIDADANDTOBAGO = "TRINIDADANDTOBAGO",
		TUNISIA = "TUNISIA",
		TURKEY = "TURKEY",
		TURKMENISTAN = "TURKMENISTAN",
		TUVALU = "TUVALU",
		UGANDA = "UGANDA",
		UKRAINE = "UKRAINE",
		UNITEDARABEMIRATES = "UNITEDARABEMIRATES",
		UNITEDKINGDOM = "UNITEDKINGDOM",
		UNITEDSTATES = "UNITEDSTATES",
		URUGUAY = "URUGUAY",
		UZBEKISTAN = "UZBEKISTAN",
		VANUATU = "VANUATU",
		VATICAN = "VATICAN",
		VENEZUELA = "VENEZUELA",
		VIETNAM = "VIETNAM",
		WESTERNSAHARA = "WESTERNSAHARA",
		YEMEN = "YEMEN",
		ZAMBIA = "ZAMBIA",
		ZIMBABWE = "ZIMBABWE",
	}

	export enum PolicyType
	{
		UNKNOWN = "UNKNOWN",
		NEWHOMES = "NEWHOMES",
		SOCIALHOUSING = "SOCIALHOUSING",
		PRS = "PRS",
		COMMERCIAL = "COMMERCIAL",
		SELFBUILD = "SELFBUILD",
		COMPLETED = "COMPLETED",
		INSOLVENCY = "INSOLVENCY",
		ASUCDIG = "ASUCDIG",
		ASUCBIG = "ASUCBIG",
		ROADSEWERBONDS = "ROADSEWERBONDS",
	}

